import { NotificationManager } from "react-notifications";
import { api } from "api";

const baseurl = "seguros/seguro";

export const getClientes = (search) => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let empresa = id_emp[5];
    const params = { empresa, search };
    return api
        .get("seguros/clientes", params)
        .then((response) => {
            return response.map((item) => ({
                value: item.id,
                label: item.nombre,
            }));
        })
        .catch((error) => {
            return [];
        });
};

export const getAgentes = (search) => {
    let ruta = window.location.href;
    let id_emp = ruta.split("/");
    let empresa = id_emp[5];
    const params = { empresa, search };
    return api
        .get("seguros/agentes", params)
        .then((response) => {
            return response.map((item) => ({
                value: item.id,
                label: item.nombre,
            }));
        })
        .catch((error) => {
            return [];
        });
};

export const reporteListadoDeSeguros = (data) => {
    let ruta = window.location.href;
    let empresa = ruta.split("/")[5];
    let reporte = "listado_de_seguros";
    const params = { empresa, reporte, ...data };
    api.getPdf("/seguros/seguro/reportes", params)
        .then((response) => {
            if (response.headers["content-type"] == "application/pdf") {
                var blob = new Blob([response.text], {
                    type: "application/pdf;charset=utf-8",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "listado_de_seguros.pdf";
                window.open(link, "_blank");
                window.URL.revokeObjectURL(link);

                return false;
            }
        })
        .catch((error) => {
            if (error.status === 404) {
                NotificationManager.info(error.body.msj, "Informacion", 5000);
            }
            if (error.status === 500) {
                NotificationManager.error(
                    "Ocurrió un error al generar reporte",
                    "Error",
                    2000
                );
            }
        });
};
